import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';
import { SmartSearchModel } from 'src/app/core/smartsearch/smartsearch';

@Injectable()
export class CategoryService extends HttpService {
	@POST('category/list')
	@Adapter(null, { isAdmin: true })
	getCategories(@Body criteria: SmartSearchModel): Observable<any> {
		return null;
	}

	@GET('category/getbyid')
	@Adapter(null, { isAdmin: true })
	getCategory(@Query('id') id: number): Observable<any> {
		return null;
	}

	@GET('category/getListSelection')
	@Adapter(null, { isAdmin: true })
	getListSelection(): Observable<any> {
		return null;
	}

	@POST('category/create')
	@Adapter(null, { isAdmin: true })
	createCategory(@Body data: string): Observable<any> {
		return null;
	}

	@POST('category/update')
	@Adapter(null, { isAdmin: true })
	updateCategory(@Body data: string): Observable<any> {
		return null;
	}

	@POST('category/delete')
	@Adapter(null, { isAdmin: true })
	deleteCategory(@Body data: string): Observable<any> {
		return null;
	}

	@POST('category/enable')
	@Adapter(null, { isAdmin: true })
	enableCategory(@Body data: string): Observable<any> {
		return null;
	}
	@POST('category/disable')
	@Adapter(null, { isAdmin: true })
	disableCategory(@Body data: string): Observable<any> {
		return null;
	}
}
